<template>
    <form class="form-wrapper" @submit.prevent="submitFormEmail">
        <div class="form-group__block">
            <InputGroup
                type="email"
                v-model="email"
                @input="sanitizeEmail"
                @blur="sanitizeEmail"
                :inputName="'email'"
                :placeholder="$t('Your Email')"
                required
                :errorMessage="emailError"
                :maxLength="40"
                autocomplete="email"
                inputClass="form-control email-input email"
                customClass="field-email field-signupform-email"
            />
        </div>
        <button
            type="submit"
            class="button button-accent btn-hover btn-hover--green"
            :class="{ 'not-changed' : !formValidation }"
        >
            <span v-if="!isSubmitting">
                {{ $t('Send Request') }}
            </span>
            <div v-else class="btn-preloader btn-preloader--green"></div>
        </button>
        <a v-if="socialGoogle" :href="socialGoogle.url" @click.prevent="$emit('link-social', socialGoogle.url)" class="social__link google">
            <span class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_12178_112752)">
                    <path d="M12.4043 10.5508V14.5026H17.896C17.6548 15.7735 16.9312 16.8497 15.8458 17.5732L19.1575 20.1429C21.087 18.3618 22.2002 15.7458 22.2002 12.6381C22.2002 11.9146 22.1353 11.2187 22.0147 10.5509L12.4043 10.5508Z" fill="#4285F4"/>
                    <path d="M6.68617 14.3486L5.93925 14.9204L3.29541 16.9798C4.97445 20.3101 8.41577 22.6107 12.4046 22.6107C15.1597 22.6107 17.4695 21.7016 19.1579 20.1432L15.8462 17.5735C14.9371 18.1858 13.7775 18.5569 12.4046 18.5569C9.75157 18.5569 7.49745 16.7665 6.69034 14.3545L6.68617 14.3486Z" fill="#34A853"/>
                    <path d="M3.29523 7.83301C2.59953 9.2059 2.20068 10.7551 2.20068 12.4063C2.20068 14.0576 2.59953 15.6068 3.29523 16.9797C3.29523 16.9889 6.69048 14.3451 6.69048 14.3451C6.4864 13.7328 6.36577 13.0835 6.36577 12.4062C6.36577 11.7289 6.4864 11.0796 6.69048 10.4674L3.29523 7.83301Z" fill="#FBBC05"/>
                    <path d="M12.4048 6.26434C13.9077 6.26434 15.2434 6.78382 16.3102 7.78572L19.2323 4.86361C17.4605 3.21239 15.16 2.20117 12.4048 2.20117C8.41598 2.20117 4.97445 4.4925 3.29541 7.83211L6.69056 10.4667C7.49757 8.05473 9.75178 6.26434 12.4048 6.26434Z" fill="#EA4335"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_12178_112752">
                    <rect width="20" height="20.4085" fill="white" transform="translate(2.2002 2.20312)"/>
                    </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="text" v-html="$t('Log in with {social}', { social: '<span>Google</span>' })"></span>
        </a>
        <div class="form-wrapper__link">
            <p>
                {{ $t('Remember your password?') }}
                <span @click.prevent="$emit('change-type', 'login')" class="link-class">
                    {{ $t('Log in') }}
                </span>
            </p>
        </div>
    </form>
</template>

<script>
import InputGroup from '/webpack-assets/vue/components/InputGroup.vue';

export default {
    emits: ['activeStepUpdate', 'update-is-two-fa'],
    components: {
        InputGroup
    },
    props: {
        socialGoogle: {
            type: Object,
        },
        authData: {
            type: Object,
        }
    },
    data() {
        return {
            email: '',
            emailError: '',
            isFormChangedEmail: false,
            formValidation: false,
            isSubmitting: false,
        }
    },
    methods: {
        sanitizeInput(value) {
            if (value !== undefined && value !== null) {
                let valueString = value.toString();
                return valueString.replace(/[а-яА-ЯёЁ]/g, '');
            }
            return value;
        },
        sanitizeEmail(event) {
            this.email = this.sanitizeInput(this.email);
            this.checkEmailErrors();
            this.checkFormChange();
        },
        checkFormChange() {
            return this.formValidation =  this.email.length && !this.emailErro;
        },
        checkEmailErrors() {
            if (this.email.length === 0) {
                this.$emit('change-height-block', 17)
                this.emailError = this.$t('{title} cannot be blank', { title: this.$t('Field') });
            } else if (typeof this.email !== 'string' || this.email.length < 3) {
                this.$emit('change-height-block', 17)
                this.emailError = this.$t('{title} should contain at least 3 characters', { title: this.$t('Field') });
            } else if (typeof this.email !== 'string' || this.email.length > 32) {
                this.$emit('change-height-block', 17)
                this.emailError = this.$t('{title} should contain at most 32 characters', { title: this.$t('Field') });
            } else {
                this.emailError = '';
                this.$emit('change-height-block', 0)
            }
        },
        async submitFormEmail() {
            this.sanitizeEmail()
            if (this.isSubmitting || !this.formValidation) return;
            this.isSubmitting = true;

            try {
                const formData = new FormData();
                formData.append('PasswordResetRequestForm[login]', this.email);
                formData.append('_csrf-frontend', this.authData.csrf);

                const response = await this.$request(`/${this.authData?.language}/auth-api/request-password-reset`, {
                    method: 'POST',
                    body: formData
                });

                const resp = await response.json();
                if (resp.status === 'error') {
                    this.emailError = resp.errors?.login ? resp.errors.login[0] : '';
                    this.isFormChangedEmail = false;
                    this.$emit('change-height-block', 17)
                } else if (resp.status === 'success') {
                    this.$emit('change-height-block', 0)
                    this.$emit('change-type', 'new-password')
                    if (resp.isTwoFA) {
                        this.$emit('update-is-two-fa', { status: true, type: 'resetLogin', ttl: resp.ttl, emailUser: resp.email, all: 4, current: 2 });
                        return;
                    }
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}
</script>

<style scoped lang="scss">
.form-input {
    &.email-input {
        padding-left: 48px !important;
    }
}
.social__link{
    margin-top: 16px;
    height: 48px;
    cursor: pointer;
    border-radius: 8px;
    background-color: rgba(78, 138, 255, 0.1);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    &:hover{
        background-color: rgba(78, 138, 255, 0.15);
    }
    .icon{
        width: 24px;
        height: 24px;
    }
    .text{
        color: #11151A;
        font-family: 'Avenir-Next', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
        :deep(span){
            font-family: 'Avenir-Next-DemiBold', sans-serif;
        }
    }
}
.link-class {
    color: #4E8AFF !important;
    transition: color 0.3s;
    &:hover {
        color: #1767FF !important;
    }
}
</style>